// extracted by mini-css-extract-plugin
export default {"active":"Sidebar_active__kvNTh","navLink":"Sidebar_navLink__DJyoe"};